import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=c2d7a210"
import script from "./TasksTable.vue?vue&type=script&lang=js"
export * from "./TasksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports